import React, { useEffect, useState } from 'react';
import { Bookmark } from 'lucide-react';
import { isInWatchlist, toggleWatchlist } from '../utils/watchlist';

interface Props {
  forumId: string;
  darkMode: boolean;
  className?: string;
}

const WatchlistButton: React.FC<Props> = ({ forumId, darkMode, className = '' }) => {
  const [active, setActive] = useState(() => isInWatchlist(forumId));

  useEffect(() => {
    const onChange = () => setActive(isInWatchlist(forumId));
    window.addEventListener('watchlist-changed', onChange);
    return () => window.removeEventListener('watchlist-changed', onChange);
  }, [forumId]);

  return (
    <button
      type="button"
      onClick={() => setActive(toggleWatchlist(forumId))}
      className={`inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-sm font-medium transition-colors ${
        active
          ? 'bg-indigo-600 text-white'
          : darkMode
            ? 'bg-gray-700 text-gray-300 hover:bg-gray-600'
            : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
      } ${className}`}
      aria-pressed={active}
      aria-label={active ? 'Takipten çık' : 'Takip et'}
    >
      <Bookmark size={16} className={active ? 'fill-current' : ''} />
      {active ? 'Takipte' : 'Takip et'}
    </button>
  );
};

export default WatchlistButton;
